import { db, auth } from "../utils/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import NonVerifiedMemberPage from "../components/NonVerifiedMemberPage";
import PleaseSignIn from "../components/PleaseSignIn";
import AdminPage from "../components/AdminPageBackUp";
import BoardMemberPage from "../components/AdminPage";
import VerifiedMemberPage from "../components/VerifiedMemberPage";
import "../styles/dashboard.css";

export default function Dashboard() {
  const [user, loading] = useAuthState(auth);
  const [member, setMember] = useState("");
  const [role, setRole] = useState();

  useEffect(() => {
    async function getUser() {
      if (auth.currentUser) {
        const docRef = doc(db, "Users", auth.currentUser.uid);
        const result = await getDoc(docRef);
        setMember(result.data());
        setRole(result.data().userTypeNumber);
      } else {
        console.log("nah");
        localStorage.removeItem("id");
        localStorage.removeItem("community");
        auth.signOut();
      }
    }

    getUser();
  }, [user]);

  if (loading)
    return (
      <div
        className="spinner-border text-primary"
        style={{ display: "flex", margin: "5em auto" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );

  if (role == 4) {
    return <AdminPage user={member} />;
  } else if (role == 3) {
    return <BoardMemberPage user={member} />;
  } else if (role == 2) {
    return <VerifiedMemberPage user={member} />;
  } else if (role == 1) {
    return <NonVerifiedMemberPage user={member} />;
  } else {
    return <PleaseSignIn />;
  }
}
